export default __webpack_public_path__ + "static/media/inclusion.59a1dc90.png";